import { API_URL } from '../../../app-config/constants';
import type AssessmentDto from '../../../types/AssessmentDto';
import { get, post } from '../request';

const BASE_URL = `${API_URL}/assessment`;

getAssessment.operation = 'READ';
export function getAssessment(assessmentId: string) {
    return get(`${BASE_URL}/${assessmentId}`);
}

getAssessmentsForReview.operation = 'READ';
export function getAssessmentsForReview(reviewId: string) {
    return get<AssessmentDto>(`${BASE_URL}?reviewId=${reviewId}`);
}

getAssessmentsForPreviewQuestionnaire.operation = 'READ';
export function getAssessmentsForPreviewQuestionnaire(cycleId: string) {
    return get(`${BASE_URL}/preview/questionnaire/${cycleId}`);
}

export function getPreviewAssessmentsForCycleModel(model: any) {
    return post(`${BASE_URL}/preview/questionnaire`, { postData: { model } });
}

createReviewerAssessmentForSelf.operation = 'COMMAND';
export function createReviewerAssessmentForSelf(reviewId: string) {
    return post(`${BASE_URL}s`, {
        postData: {
            reviewId,
        },
    });
}

answerAssessment.operation = 'COMMAND';
export function answerAssessment(assessmentId: string, assessmentAnswers: any) {
    return post(`${BASE_URL}/${assessmentId}/answers`, {
        postData: assessmentAnswers,
    });
}

moderateAssessment.operation = 'COMMAND';
export function moderateAssessment(assessmentId: string, assessmentAnswers: any, authorId: string) {
    return post(`${BASE_URL}/${assessmentId}/answers/${authorId}`, {
        postData: assessmentAnswers,
    });
}

indicateDone.operation = 'COMMAND';
export function indicateDone(assessmentId: string, indicated: any) {
    return post(`${BASE_URL}/${assessmentId}/indicatedDone`, {
        postData: indicated,
    });
}
